<template lang="pug">
  v-icon(v-if="getMark(markType)" :color="color ? color : getMark(markType).color") {{ getMark(markType).icon }}
  v-icon(v-else :color="color ? color : CLEAR_ICON.color") {{ CLEAR_ICON.icon }}
</template>

<script>
import { useCardMarkType } from "@/composables/dispatch/useCardMarkType";

export default {
  setup() {
    const { CLEAR_ICON, getMark } = useCardMarkType();

    return {
      CLEAR_ICON,
      getMark
    };
  },
  props: {
    markType: {
      type: String,
      default: "00"
    },
    color: {
      type: String,
      default: null
    }
  }
};
</script>
